import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { Button, Form, Input, Alert } from 'antd';
import TopBar from '../TopBar/TopBar';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
      setError(null);
    } catch (error: any) {
      setError(error.message);
      setSuccess(false);
    }
  };

  return (
    <div className="page-container">
      <TopBar className="title" title="Forgot Password" />
      <h2>Forgot Password</h2>
      <Form onFinish={handleSubmit}>
        <Form.Item>
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Send Password Reset Email
          </Button>
        </Form.Item>
      </Form>
      {error && <Alert message={error} type="error" />}
      {success && (
        <Alert
          message="Password reset email sent successfully! Please check your inbox."
          type="success"
        />
      )}
    </div> 
  );
};

export default ForgotPassword;
